export enum LlmDocumentType {
    URL = 'Url',
    FILE = 'File'
}
